import { useContext } from "react";
import { MeasurementsContext } from "components/shipment-editor/contexts/measurements-provider";

export const useMeasurements = () => useContext(MeasurementsContext);
